import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const Recruitment = () => {
  return (
    <div className="space-y-6">
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">👥 Recruitment</h1>
          <p className="text-muted-foreground">applicants, open positions</p>
        </div>
      </StaggeredAnimation>

      <StaggeredAnimation delay={200} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Recruitment Dashboard</CardTitle>
            <CardDescription>applicants, open positions</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">Recruitment content will be displayed here...</p>
          </CardContent>
        </Card>
      </StaggeredAnimation>
    </div>
  );
};

export default Recruitment;